var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0.125H4C1.875 0.125 0.125 1.875 0.125 4V34C0.125 36.125 1.875 37.9375 4.0625 37.9375H34.0625C36.1875 37.9375 38 36.1875 38 34V4C37.9375 1.875 36.125 0.125 34 0.125ZM35.125 34C35.125 34.625 34.625 35.125 34 35.125H4C3.375 35.125 2.875 34.625 2.875 34V4C2.9375 3.375 3.375 2.9375 4 2.9375H34C34.625 2.9375 35.125 3.4375 35.125 4.0625V34Z",
    fill: "#0092CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 12.0625L15.375 22.9375L11.75 19.3125C11.1875 18.75 10.3125 18.75 9.75 19.3125C9.1875 19.875 9.1875 20.75 9.75 21.3125L14.375 25.9375C14.625 26.1875 15 26.375 15.375 26.375C15.75 26.375 16.125 26.25 16.375 25.9375L28.25 14.0625C28.8125 13.5 28.8125 12.625 28.25 12.0625C27.6875 11.5 26.8125 11.5 26.25 12.0625Z",
    fill: "#0092CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg64);
export default __webpack_public_path__ + "static/media/svg64.e945cfd401a69d11c5d16d1ff614d091.svg";
export { ForwardRef as ReactComponent };